import type { AuthProviderProps } from 'react-oidc-context';
import { getAuthAuthority, getAuthClientId, getAuthRedirectUri, getBasePath } from './env';

export const oidcConfig: AuthProviderProps = {
  authority: getAuthAuthority(),
  client_id: getAuthClientId(),
  redirect_uri: getAuthRedirectUri(),
  post_logout_redirect_uri: getBasePath(),
  onSigninCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
